import { CountryCode } from "./country-config";

export const SIGNING_PROVIDER_BY_COUNTRY: Record<CountryCode, string> = {
	SE: "sbid",
	FI: "ftn",
	// Placeholder until the Norwegian Keycloak identity provider alias is confirmed.
	NO: "bankid-no",
};

export const getSigningProviderId = (country: CountryCode): string =>
	SIGNING_PROVIDER_BY_COUNTRY[country];

export const SIMULATOR_IDP = "simulator";

export const getSimulatorAuthParams = (): Record<string, string> => ({
	acr_values: `idp:${SIMULATOR_IDP}`,
});

export const getSilentAuthParams = (
	country: CountryCode
): Record<string, string> => ({
	prompt: "none",
	...(country === "FI" ? { kc_idp_hint: "" } : {}),
});

export const getInteractiveAuthParams = ({
	country,
	kcIdpHint,
	ftnIdp,
}: {
	country: CountryCode;
	kcIdpHint: string;
	ftnIdp?: string;
}): Record<string, string> => {
	let acrValues = `idp:${getSigningProviderId(country)}`;
	if (country === "FI" && ftnIdp) {
		acrValues += ` ftn_idp:${ftnIdp}`;
	}

	return {
		// Only FI runs the `prompt=none` round-trip, so FI is the only country
		// that can reach an interactive login with a reusable Keycloak session
		// that has to be overridden. Sending it for SE makes Keycloak reject the
		// Simulator, which needs no re-authentication to force.
		...(country === "FI" ? { prompt: "login", ui_locales: "fi" } : {}),
		...(kcIdpHint ? { kc_idp_hint: kcIdpHint } : {}),
		acr_values: acrValues,
	};
};

export const OVERRIDABLE_AUTH_PARAMS = ["acr_values", "kc_idp_hint"] as const;
